import { createLazyComponent, LazyModule } from 'owa-bundling';
import { FilePickerAction, FileSelectionFilter } from 'owa-filepicker-store';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "AttachmentFilePicker" */ './lazyIndex');
});
// Delay loaded components
export var AttachmentLocalComputerFilePicker = createLazyComponent(lazyModule, function (m) { return m.AttachmentLocalComputerFilePicker; });
export { FilePickerAction, FileSelectionFilter };
//# sourceMappingURL=index.js.map